import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Input, Row, Select, Space, Checkbox, Typography } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Datepicker } from "@ijavad805/react-datepicker";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import ModalDestination from "../../../components/Modal/Destination/DestinationModal";
import ModalOrigin from "../../../components/Modal/Origin/OriginModal";
import ModalJens from "../../../components/Modal/Jens/JensModal";
import ModalOperator from "../../../components/Modal/Operator/OperatorModal";
import ModalPerson from "../../../components/Modal/Person/PersonModal";
import ModalMachineType from "../../../components/Modal/MachineType/MachineType";
import Modal from "../../../components/Modal/Modal";

const { Title } = Typography;

export default function ReportBodyWeightBridge() {
  const [form] = Form.useForm();
  const [machineData, setMachineData] = useState("");
  const [machineTypeData, setMachineTypeData] = useState("");
  const [personData, setPersonData] = useState("");
  const [jensData, setJensData] = useState("");
  const [originData, setOriginData] = useState("");
  const [destinationData, setDestinationData] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [checkboxState, setCheckboxState] = useState({
    machineType: false,
    machine: false,
    person: false,
    jens: false,
    origin: false,
    destination: false,
  });
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalMachineType, setShowModalMachineType] = useState(false);
  const [showModalPerson, setShowModalPerson] = useState(false);
  const [showModalJens, setShowModalJens] = useState(false);
  const [showModalOrigin, setShowModalOrigin] = useState(false);
  const [showModalDestination, setShowModalDestination] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedMachineTypeIds, setSelectedMachineTypeIds] = useState([]);
  const [selectedPersonIds, setSelectedPersonIds] = useState([]);
  const [selectedJensIds, setSelectedJensIds] = useState([]);
  const [selectedOriginIds, setSelectedOriginIds] = useState([]);
  const [selectedDestinationIds, setSelectedDestinationIds] = useState([]);

  const [operationTypes, setOperationTypes] = useState([]);

  const handleCheckboxChanges = (e) => {
    const { name, checked } = e.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const getSelectedTypeIds = () => {
    const typesMap = {
      "همه موارد": 3,
      "بارگیری": 1,
      "تخلیه بار": 2,
    };
    return operationTypes.map((type) => typesMap[type]);
  };

  const handleSubmitClick = () => {
    const selectedTypeIds = getSelectedTypeIds();
    const payload = {
      type: selectedTypeIds,
      selectedMachineTypeIds: checkboxState.machineType ? selectedMachineTypeIds : [],
      selectedIds: checkboxState.machine ? selectedIds : [],
      selectedPersonIds: checkboxState.person ? selectedPersonIds : [],
      selectedJensIds: checkboxState.jens ? selectedJensIds : [],
      selectedOriginIds: checkboxState.origin ? selectedOriginIds : [],
      selectedDestinationIds: checkboxState.destination ? selectedDestinationIds : [],
      startDate: dateFrom || null,
      endDate: dateTo || null,
    };
    localStorage.setItem("reportPayloadWeightBridge", JSON.stringify(payload));
    navigate("/reports-weight/lists");
  };

  const handleOperationTypeChange = (values) => {
    const allItems = ["همه موارد", "بارگیری", "تخلیه بار"];
    const wasAllSelected = operationTypes.includes("همه موارد");
    const isAllSelected = values.includes("همه موارد");

    if (isAllSelected && !wasAllSelected) {
      setOperationTypes(allItems);
    } else if (!isAllSelected && wasAllSelected) {
      setOperationTypes(values);
    } else if (isAllSelected && values.length < allItems.length) {
      setOperationTypes(values.filter(v => v !== "همه موارد"));
    } else {
      setOperationTypes(values);
    }
  };

  return (
    <DashboardLayout>
      <div className="p-4 bg-gray-50 min-h-screen">
        <Form form={form} layout="vertical" onFinish={handleSubmitClick}>
          <Card 
            title={
              <div className="flex items-center gap-2">
                <FilterOutlined style={{ color: "#fff" }} />
                <Title level={4} className="mb-0" style={{ color: "#fff", margin: 0 }}>فیلتر گزارش باسکول</Title>
              </div>
            }
            className="shadow-lg mb-6"
            headStyle={{ background: "linear-gradient(180deg, #001529 0%, #002140 100%)", border: "none", color: "#fff" }}
            bodyStyle={{ padding: "24px" }}
          >
            {/* Operation Type Section */}
            <Card 
              title="نوع عملیات" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Select
                mode="multiple"
                placeholder="انتخاب نوع عملیات"
                value={operationTypes}
                onChange={handleOperationTypeChange}
                style={{ width: "100%" }}
                size="large"
                options={[
                  { label: "همه موارد", value: "همه موارد" },
                  { label: "بارگیری", value: "بارگیری" },
                  { label: "تخلیه بار", value: "تخلیه بار" },
                ]}
              />
            </Card>

            {/* Filters Section */}
            <Card 
              title="فیلترها" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                {[
                  { label: "نوع دستگاه", name: "machineType", modalSetter: setShowModalMachineType, dataSetter: setMachineTypeData, selectedIdsSetter: setSelectedMachineTypeIds, modalState: showModalMachineType, modalComponent: ModalMachineType },
                  { label: "دستگاه", name: "machine", modalSetter: setShowModal, dataSetter: setMachineData, selectedIdsSetter: setSelectedIds, modalState: showModal, modalComponent: Modal },
                  { label: "راننده", name: "person", modalSetter: setShowModalPerson, dataSetter: setPersonData, selectedIdsSetter: setSelectedPersonIds, modalState: showModalPerson, modalComponent: ModalPerson },
                  { label: "کالا", name: "jens", modalSetter: setShowModalJens, dataSetter: setJensData, selectedIdsSetter: setSelectedJensIds, modalState: showModalJens, modalComponent: ModalJens },
                  { label: "مبدا", name: "origin", modalSetter: setShowModalOrigin, dataSetter: setOriginData, selectedIdsSetter: setSelectedOriginIds, modalState: showModalOrigin, modalComponent: ModalOrigin },
                  { label: "مقصد", name: "destination", modalSetter: setShowModalDestination, dataSetter: setDestinationData, selectedIdsSetter: setSelectedDestinationIds, modalState: showModalDestination, modalComponent: ModalDestination },
                ].map((item) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={item.name}>
                    <Space direction="vertical" className="w-full">
                      <Checkbox
                        name={item.name}
                        checked={checkboxState[item.name]}
                        onChange={handleCheckboxChanges}
                        className="font-medium"
                      >
                        {item.label}
                      </Checkbox>
                      <Input
                        readOnly
                        onClick={(e) => {
                          e.stopPropagation();
                          item.modalSetter(true);
                        }}
                        placeholder={`انتخاب ${item.label}`}
                        value={
                          item.name === "machine" ? machineData :
                          item.name === "machineType" ? machineTypeData :
                          item.name === "person" ? personData :
                          item.name === "jens" ? jensData :
                          item.name === "origin" ? originData :
                          item.name === "destination" ? destinationData : ""
                        }
                        addonAfter={
                          <SearchOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              item.modalSetter(true);
                            }} 
                            className="cursor-pointer text-blue-600 hover:text-blue-800"
                          />
                        }
                        className="cursor-pointer"
                      />
                    </Space>
                  </Col>
                ))}
              </Row>
            </Card>

            {/* Date Range Section */}
            <Card 
              title="بازه تاریخی" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item label="از تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="از تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateFrom(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="تا تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="تا تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateTo(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Submit Button */}
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                size="large"
                className="w-full h-12 text-lg font-semibold shadow-md hover:shadow-lg transition-all"
                style={{
                  background: "linear-gradient(180deg, #001529 0%, #002140 100%)",
                  border: "none",
                }}
              >
                نمایش گزارش
              </Button>
            </Form.Item>
          </Card>
        </Form>

        {/* Modals for selecting data */}
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          setData={machineData || ""}
          onSelectedIdsChange={(data) => {
            if (data && typeof data === "object" && data.title) {
              setMachineData(data.title);
              setSelectedIds([data.id]);
            } else if (Array.isArray(data)) {
              setSelectedIds(data);
            }
          }}
        />
        <ModalMachineType
          showModal={showModalMachineType}
          setShowModal={setShowModalMachineType}
          setData={machineTypeData || ""}
          onSelectedIdsChange={(ids) => {
            setSelectedMachineTypeIds(Array.isArray(ids) ? ids : [ids]);
          }}
        />
        <ModalPerson
          showModal={showModalPerson}
          setShowModal={setShowModalPerson}
          setData={personData || ""}
          onSelectedIdsChange={(ids) => {
            setSelectedPersonIds(Array.isArray(ids) ? ids : [ids]);
          }}
        />
        <ModalJens
          showModal={showModalJens}
          setShowModal={setShowModalJens}
          setData={jensData || ""}
          onSelectedIdsChange={(ids) => {
            setSelectedJensIds(Array.isArray(ids) ? ids : [ids]);
          }}
        />
        <ModalOrigin
          showModal={showModalOrigin}
          setShowModal={setShowModalOrigin}
          setData={originData || ""}
          onSelectedIdsChange={(ids) => {
            setSelectedOriginIds(Array.isArray(ids) ? ids : [ids]);
          }}
        />
        <ModalDestination
          showModal={showModalDestination}
          setShowModal={setShowModalDestination}
          setData={destinationData || ""}
          onSelectedIdsChange={(ids) => {
            setSelectedDestinationIds(Array.isArray(ids) ? ids : [ids]);
          }}
        />
      </div>
    </DashboardLayout>
  );
}
